/**
 * Created by falknisius on 15.05.17.
 */
// ADD AND CHANGE STRINGS HERE
// ------------------------------------------------------------------------------------------------------------------

const STRINGS = {
  APP_TITLE: {
    de: 'Tarifbeschreibungseditor',
    en: 'Tariff description editor'
  },

  YES: {
    de: 'Ja',
    en: 'Yes'
  },

  NO: {
    de: 'Nein',
    en: 'NO'
  },

  ERROR_HTTP_COMMUNICATION: {
    de: 'Netzwerk Kommunikation nicht efolgreich',
    en: 'communication error'
  },

  ERROR_ACTIVATIONCODE_EMPTY: {
    de: 'Der Activierungscode muss ausgefüllt werden.',
    en: 'activation code can\'t be empty.'
  },

  ERROR_INVALID_EMAIL: {
    de: 'Die Emailadresse scheint nicht korrekt zu sein.',
    en: 'The email address seems to be invalid.'
  },

  ERROR_PASSWORD_SHORT: {
    de: 'Das Passwort ist zu kurz.',
    en: 'The password is too short.'
  },

  ERROR_PASSWORD_POLICY: {
    de: 'Das Passwort entspricht nicht den Anforderungen (Groß-, Kleinbuchstaben, Ziffern, Sonderzeichen).',
    en: 'The password does\'nt match the requirements. (upper case, lower case letters, digits and special chars)'
  },

  ERROR_PASSWORD_NOTMATCH: {
    de: 'Die Passworte stimmen nicht überein.',
    en: 'The passwords doesn\'t match.'
  },

  REGISTRATION_ERROR: {
    de: 'Registrierungsfehler',
    en: 'Registration Error'
  },

  LOGIN_ERROR: {
    de: 'Anmeldefehler',
    en: 'Login Error'
  },

  REGISTRATION_SUCCESS_TITLE: {
    de: 'Registrierung erfolgreich',
    en: 'Registrations succeed'
  },

  REGISTRATION_SUCCESS_TEXT: {
    de: 'Sie haben sich erfoglreich registriert und können mit der Pflege der Tarifbeschreibungen beginnen.',
    en: 'You have successfully registered and can start with the maintenance of the tariff descriptions.'
  },

  'invalid inputs': {
    de: 'Es sind nicht alle Felder korrekt ausgefüllt.',
    en: 'There incvalid inputs.'
  },

  'code not found': {
    de: 'Dieser Aktivierungscode ist nicht bekannt.',
    en: 'Activationcode invalid.'
  },

  'user not found': {
    de: 'Nutzer ist nicht bekannt.',
    en: 'User not found.'
  },

  'code in use': {
    de: 'Dieser Aktivierungscode wurde bereits verwendet.',
    en: 'Activationcode is already used.'
  },

  'nickname is used in this group': {
    de: 'Ein Nutzer mit dieser Email wurde bereits registriert.',
    en: 'There is already one User with this email registered.'
  },

  'Bad credentials': {
    de: 'Ungültige Zugangsdaten.',
    en: 'Invalid credentials.'
  },

  'Tariff already exists': {
    de: 'Eine Tarifbeschreibung mit diesem Namen existiert bereits.',
    en: 'A tariff description with this name already exists.'
  },

  TARIFF_NAME: {
    de: 'Name',
    en: 'Name'
  },

  TARIFF_DESCRIPTION: {
    de: 'Beschreibung',
    en: 'Description'
  },

  TARIFF_VISIBLE_FROM: {
    de: 'Sichtbar ab',
    en: 'Visible from'
  },

  TARIFF_VISIBLE_FROM_HELP: {
    de: 'Sie können das Datum auch mit der Tastatur eingeben.',
    en: 'You can also enter the date using the keyboard.'
  },

  ADD_TARIFF: {
    de: 'Tarifbeschreibung hinzufügen',
    en: 'Add tariff description'
  },

  EDIT_TARIFF: {
    de: 'Tarifbeschreibung bearbeiten',
    en: 'Update tariff description'
  },

  NO_TARIFFS: {
    de: 'Noch keine Tarife angelegt.',
    en: 'No Tarifs stored.'
  },

  NO_FILTERED_TARIFFS: {
    de: 'Keine Tarife für den eingestellten Filter vorhanden.',
    en: 'No tariffs for the set filter available.'
  },

  CANCEL: {
    de: 'Abbrechen',
    en: 'Cancel'
  },

  OK: {
    de: 'Ok',
    en: 'Ok'
  },

  SAVE_TARIFF: {
    de: 'Speichern',
    en: 'Save'
  },

  SAVE_PASSWORD: {
    de: 'Speichern',
    en: 'Save'
  },

  TARIFF_NAME_EMPTY: {
    de: 'Der Tarifselector darf nicht leer sein.',
    en: 'Name can\'t be empty.'
  },

  TARIFF_DESCRIPTION_EMPTY: {
    de: 'Der Tarifbeschreibung darf nicht leer sein.',
    en: 'Description can\'t be empty.'

  },

  UPDATE_TARIFF:{
    de: 'Aktualisieren',
    en: 'Update'
  },

  LOGIN:{
    de: 'Login',
    en: 'Login'
  },

  LOGOUT:{
    de: 'Logout',
    en: 'Logout'
  },

  EMAIL: {
    de: 'E-Mail-Adresse',
    en: 'email'
  },

  PASSWORD_RESET: {
    de: 'Neues Passwort eingeben',
    en: 'Insert new password'
  },

  PASSWORD: {
    de: 'Passwort',
    en: 'password'
  },

  PASSWORD2: {
    de: 'Passwort Wiederholung',
    en: 'Repeat password'
  },

  RESET_ERROR: {
    de: 'Passwort ändern Fehler',
    en: 'Change password error'
  },

  RESET_SUCCESS_TEXT: {
    de: 'Sie haben Ihr Passwort erfolgreich geändert und können mit der Pflege der Tarifbeschreibungen fortfahren.',
    en: 'You have successfully changed your password and can continue with the maintenance of the tariff descriptions.'
  },

  RESET_SUCCESS_TITLE: {
    de: 'Passwortänderung erfolgreich',
    en: 'Password change succeed'
  },

  REGISTER: {
    'de': 'Registrieren',
    'en': 'Register'
  },

  FORGOT_ERROR: {
    de: 'Passwort vergessen Fehler',
    en: 'Password forgot error'
  },

  FORGOT_SEND_SUCCESS: {
    de: 'Eine Nachricht mit Zurücksetzanweisungen wurde erfolgreich an "$0" verschickt. Sie haben $1 Minuten Zeit, den darin enthaltenen Link zu klicken und ein neues Passwort einzugeben.',
    en: 'A message with reset instructions was successfully sent to "$0". You have $1 minutes to click on the link in the message and enter a new password.'
  },

  FORGOT_TITLE: {
    'de': 'Passwort vergessen',
    'en': 'Forgot password'
  },

  FORGOT_SEND: {
    'de': 'Passwort zurücksetzen',
    'en': 'Reset password'
  },

  ERROR_HEADLINE: {
    de: 'Fehler',
    en: 'Error'
  },

  NO_INPUT: {
    de: 'Keine Eingaben',
    en: 'no input'
  },

  TARIFF_DELETE_TEXT: {
    de: 'Sind sie sich sicher die Beschreibung für den Tarif "<b>$0</b>" zu löschen?<br>Dieser Schritt kann nicht rückgängig gemacht werden.',
    en: 'Are you sure you want to remove the description for tariff "<b>$0</b>"?<br>This step can not be undone.'
  },

  TARIFF_DELETE: {
    de: 'Tarif löschen',
    en: 'Delete Tariff'
  },

  TARIFF_LABEL_FILTER: {
    de: 'Filter',
    en: 'Filter'
  },

  TARIFF_DELETE_FILTER: {
    de: 'lösche Filter',
    en: 'delete filter'
  },

  /*


    ERROR_WRONG_REQUEST: {
      de: 'Anwendungsprotokoll nicht korrekt umgesetzt',
      en: 'application protocoll mismatch'
    }
  */
}

// THIS IS SOURCE CODE BELOW THIS LINE
// ------------------------------------------------------------------------------------------------------------------

const applyArgsToString = (string, args) => {
  let stringWithAppliedArgs = string
  let i = 0
  args.forEach(arg => {
    stringWithAppliedArgs = stringWithAppliedArgs.replace(`$${i}`, arg)
    i += 1
  })
  return stringWithAppliedArgs
}

export let target = {
  supportedLanguages: ['de', 'en'],
  choosenLanguage: 'de'
}

/**
 * Returns the string for the requested key in the prefererred language.
 * If it is not found all languages of higher priority are checked (as specified in config or target config).
 * If not present there either the key itself will be returned
 *
 * If no preferred language is given, the first language as specified in config or target config is used.
 */
export default (key, args = [], preferredLanguage = target.choosenLanguage) => {
  // return 'key' if key does not exist
  if (!STRINGS[key]) {
    if (!args || args.length > 0) {
      return `${key} (${JSON.stringify(args)}`
    }
    return key
  }

  const strings = STRINGS[key] ? STRINGS[key] : {}

  // check if string exists in preferred language
  if (strings[preferredLanguage]) {
    return applyArgsToString(strings[preferredLanguage], args)
  }

  // find best language
  const bestAvailLanguage = target.supportedLanguages.filter(language => Object.keys(strings).indexOf(language) >= 0)
  if ( bestAvailLanguage.length)
    return applyArgsToString(strings[bestAvailLanguage[0]], args)
  else {
    if (!args || args.length > 0) {
      return `${key} (${JSON.stringify(args)}`
    }
    return key
  }
}
